import T from 'utils/T';
import ex from 'utils/ex';
import HBox from './HBox';

export default function SummaryBloodGlocoseCountBox(props) {
  const {
    size,
    label,
    value,
    low,
    high,
    ...rest
  } = props || {};
  return (
    <HBox {...ex(['SummaryBloodGlocoseCountBox', size], rest)}>
      <div>
        {label}
      </div>
      <HBox>
        <div>
          {high || 0}
        </div>
        <div>
          {low || 0}
        </div>
      </HBox>
    </HBox>
  );
}
